// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { Box } from 'grommet'
import PropTypes from 'prop-types'

import { getQueryArray } from '../utils'
import { Typography } from '../../../../components'

import { ListComponent } from './ListComponent'

const SimilarMatches = ({ data, handleListClick, i18nTranslation }) => (
  <Box
    pad={{ bottom: 'small' }}
    border={{
      side: 'bottom',
      color: 'border-weak',
      size: 'small'
    }}
  >
    <Typography
      type="text"
      testId="similar-search-title"
      color="text-weak"
      size="xsmall"
      margin={{ vertical: 'small' }}
    >
      {i18nTranslation('global_search.similar_searches')}
    </Typography>
    <ListComponent
      data-testid="similar-search-button"
      content={getQueryArray(data)}
      handleListClick={handleListClick}
    />
  </Box>
)

SimilarMatches.propTypes = {
  data: PropTypes.array.isRequired,
  handleListClick: PropTypes.func.isRequired,
  i18nTranslation: PropTypes.any.isRequired
}

export { SimilarMatches }
